import { AdminRoster, Card, QueryContent } from '@kanos/web-core';
import { useQuery } from '@tanstack/react-query';
import { staffQuery, useAdminChange } from './queries';

/**
 * The platform's own team (ADR-016): everyone who signed in through the realm `plattform`. Any
 * administrator makes another one, or takes it back - never from the last one.
 */
export function StaffPage() {
  const staff = useQuery(staffQuery);
  const change = useAdminChange();

  return (
    <Card
      id="platform-staff"
      title="Plattform-Team"
      description="Alle, die sich schon einmal an der Plattform angemeldet haben. Admins verwalten Partner-Apps und dieses Team."
    >
      <QueryContent query={staff}>
        {(list) => (
          <AdminRoster
            managed="die Plattform"
            change={change}
            people={list.map((member) => {
              const name = member.displayName ?? member.email ?? member.subject;
              return {
                ...member,
                name,
                detail: member.email && member.email !== name ? member.email : null,
              };
            })}
          />
        )}
      </QueryContent>
    </Card>
  );
}
